// extracted by mini-css-extract-plugin
export default {"form":"NewPostForm_form__l+7JQ","formControll":"NewPostForm_formControll__IJccg","actions":"NewPostForm_actions__uVQT-"};